import PasswordReset from './styled';

export default PasswordReset;
